module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_9016.d949267d.png";